import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/map';
import { CookieService } from 'ng2-cookies';
import { AuthService } from './auth.service';
import { UserModel } from '../models/user.model';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private cookieService: CookieService, private authService: AuthService) {}

  canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      this.authService.verifyToken().subscribe(
        user => {
          if (user) {
            this.authService.featureTogglesFlags = user.featureToggles;
            this.authService.userModel.next(new UserModel(user));
            this.authService.user = user;
            return resolve(true);
          }
          this.router.navigate(['/sign-in'], { queryParams: { sessionExpired: true } });
          this.logoutUser();
          return resolve(false);
        },
        () => {
          this.router.navigate(['/sign-in'], { queryParams: { sessionExpired: true } });
          this.logoutUser();
          return resolve(false);
        }
      );
    });
  }

  logoutUser(): void {
    this.authService.userModel.next({} as UserModel);
    this.cookieService.delete('token');
    this.authService.token = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.guard.ts